module.exports = __webpack_public_path__ + "static/media/Untitled-4.e1539950.png";